const firebaseConfig = {
  apiKey: "AIzaSyCUwOCKHL0FTNAuA0J0MUaQ8XQwp7dK1Tw",
  authDomain: "skyline-travel-1e5c7.firebaseapp.com",
  projectId: "skyline-travel-1e5c7",
  storageBucket: "skyline-travel-1e5c7.appspot.com",
  messagingSenderId: "544373407978",
  appId: "1:544373407978:web:5adffc4cb9de83b7491793"
};
export default firebaseConfig;   